module.exports = __webpack_public_path__ + "img/netherlands.b1f1be5d.svg";